import R from 'ramda'
import {
  numCol,
  strCol,
  dateCol,
  dateTimeCol,
  intCol,
} from '@integec/grid-tools/lib/cols'
import { toSelectionColProps } from '@integec/grid-tools/lib/utils'
import { yesNoMap, yesNoYNMap } from 'core'

export const PlantHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID',
    isKey: true,
    width: 200,
    maxLength: 10,
  }),
  // strCol({ ident: 'region', display: 'Region', isKey: true, width: 300 }),
  strCol({ ident: 'plantId', display: 'Plant ID', isKey: true, maxLength: 10 }),
  strCol({
    ident: 'plantName',
    display: 'Plant Name',
    width: 150,
    isRequired: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'eiaPlantCode',
    display: 'EIA Plant Code',
    width: 200,
    isKey: true,
  }),
  strCol({
    ident: 'isoResourceId',
    display: 'ISO Resource ID',
    width: 200,
    isFiltered: true,
  }),

  strCol({
    ident: 'country',
    display: 'Country',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'nearestCity',
    display: 'Nearest City',
    isFiltered: true,
    width: 200,
  }),
  strCol({
    ident: 'stateProvince',
    display: 'State or Province',
    isFiltered: true,
    width: 200,
    maxLength: 2,
    isRequired: true,
  }),

  strCol({
    ident: 'timeZone',
    display: 'Time Zone',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  // strCol({
  //   ident: 'daylightSaving',
  //   display: 'Daylight Saving',
  //   isFiltered: true,
  //   keymap: yesNoMap,
  //   isRequired: true,
  //   // ...toSelectionColProps(yesNoMap),
  //   //...toSelectionColProps(yesNoYNMap),
  // }),
  strCol({
    ident: 'latitude',
    display: 'Latitude',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'longitude',
    display: 'Longitude',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'plantCapPoi',
    display: 'Plant Capacity at POI',
    width: 250,
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'onSiteStorage',
    display: 'On-Site Connected Energy Storage',
    width: 300,
    isFiltered: true,
    isRequired: true,
    // keymap: yesNoYNMap,
    //  ...toSelectionColProps(yesNoYNMap),
  }),
  strCol({
    ident: 'plantOwnershipStatus',
    display: 'Plant Ownership Status',
    isKey: false,
    width: 200,
    isRequired: true,
  }),

  strCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    width: 200,
    isFiltered: true,
    isRequired: true,
  }),
  // strCol({
  //   ident: 'transferToEntityId',
  //   display: 'Transfer to Entity ID',
  //   isFiltered: true,
  //   maxLength: 10,
  // }),

  // modifierCol,
  // modifiedDateCol,
]

export const SubgroupHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID',
    isKey: true,
    width: 200,
  }),
  strCol({ ident: 'plantId', display: 'Plant ID', isKey: true }),
  strCol({
    ident: 'groupIdName',
    display: 'Group ID/Name',
    width: 200,
    isFiltered: true,
  }),
  intCol({
    ident: 'subgroupId',
    display: 'Subgroup ID',
    width: 200,
    isKey: true,
  }),
  strCol({
    ident: 'subgroupName',
    display: 'Subgroup Name',
    width: 200,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'elevation',
    display: 'Subgroup Elevation',
    width: 200,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'windRegime',
    display: 'Wind Regime',
    width: 200,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'annualAvgWindspeed',
    display: 'Annual Average Wind Speed',
    width: 300,
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'scadaManufacturer',
    display: 'SCADA Manufacturer',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'scadaModel',
    display: 'SCADA Model',
    width: 200,
    isFiltered: true,
    isRequired: true,
  }),
  dateCol({
    ident: 'commissionDate',
    display: 'Commercial Operation Date',
    width: 250,
    isFiltered: true,
    dataFormat: 'MM/DD/YYYY',
    isRequired: true,
  }),
  // dateCol({
  //   ident: 'effectiveDate',
  //   display: 'Effective Date (mm/dd/yyyy)',
  //   isFiltered: true,
  //   dataFormat: 'MM/DD/YYYY',
  //   isRequired: true,
  // }),
  // numCol({
  //   ident: 'totalInstalledCap',
  //   display: 'Total Installed Cap (MW)',
  //   isFiltered: true,
  //   isRequired: true,
  // }),
  numCol({
    ident: 'numberTurbines',
    display: 'Total Number of Turbines',
    width: 250,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'trubineSystemMw',
    display: 'Turbine System Capacity',
    width: 250,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'maxTurbineCapacity',
    display: 'Max Turbine Capacity',
    width: 250,
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineManufacturer',
    display: 'Turbine Manufacturer',
    isFiltered: true,
    width: 300,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineModel',
    display: 'Turbine Model',
    width: 200,
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineModelVersion',
    display: 'Turbine Model Version',
    width: 250,
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineType',
    display: 'Turbine Type',
    isFiltered: true,
    width: 350,
    alignment: 'left',
    ellipsis: true,
    isRequired: true,
  }),
  numCol({
    ident: 'rotorHeight',
    display: 'Rotor Height',
    width: 200,
    isFiltered: true,
    isRequired: true,
    min: 0,
  }),
  numCol({
    ident: 'rotorDiameter',
    display: 'Rotor Diameter',
    width: 200,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'cutInWindspeed',
    display: 'Cut-in Wind Speed',
    width: 250,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'lowCutOutWindspeed',
    display: 'Low Cut‐out Wind Speed',
    width: 250,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'highCutOutWindspeed',
    display: 'High Cut‐out Wind Speed',
    width: 250,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'turbulenceIntensity',
    display: 'Turbulence Intensity',
    isFiltered: true,
    alignment: 'left',
    ellipsis: true,
    width: 200,
    isRequired: true,
  }),
  numCol({
    ident: 'windShearId',
    display: 'Wind Shear',
    isFiltered: true,
    alignment: 'left',
    ellipsis: true,
    width: 250,
    isRequired: true,
  }),
  numCol({
    ident: 'refAnemometerHeight',
    display: 'Reference Anemometer Height',
    width: 300,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'minOperatingTemp',
    display: 'Minimal Operating Temperature',
    width: 300,
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'maxOperatingTemp',
    display: 'Maximum Operating Temperature',
    width: 300,
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'subgroupOwnershipStatus',
    display: 'Subgroup Ownership Status',
    width: 300,
    isFiltered: true,
    isRequired: true,
  }),
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    width: 200,
    isFiltered: true,
    dataFormat: 'MM/DD/YYYY',
    isRequired: true,
  }),

  // strCol({
  //   ident: 'transferToEntity',
  //   display: 'Transfer to Entity ID',
  //   isFiltered: true,
  // }),

  // modifierCol,
  // modifiedDateCol,
]

const headerWithFormatter = headers => {
  return headers.map(header =>
    header.ident === 'extension'
      ? {
          ...header,
          dataFormatter: ({ rowData }) => rowData.extension?.causecode1 || '',
        }
      : header
  )
}

export const NercEventHeaders = (width, contribConditionList) => {
  const conMap = R.compose(
    R.fromPairs,
    R.map(d => [d.contOpCode, d.contOpCode + ' - ' + d.contOpCondition])
  )(contribConditionList)

  const headers = [
    // strCol({ ident: 'entityId', display: 'NCR ID', isKey: true }),
    strCol({ ident: 'plantId', display: 'Plant ID', isKey: true }),
    strCol({
      ident: 'eventId',
      display: 'Event ID',
      isKey: true,
      sortOrder: 'asc',
    }),
    strCol({ ident: 'eventstartTimeZone', display: 'Time Zone', isKey: true }),
    dateTimeCol({
      ident: 'eventstart',
      display: 'Start Date/Time',
      isKey: true,
      width: 150,
      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
      sortOrder: 'asc',
    }),
    dateTimeCol({
      ident: 'eventend',
      display: 'End Date/Time',
      isFiltered: true,
      width: 150,
      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
      // sortOrder: 'asc',
    }),
    strCol({
      ident: 'eventtype',
      display: 'Event Type',
      width: 150,
      isFiltered: true,
    }),
    intCol({
      ident: 'causecode',
      display: 'Primary Cause Code',
      width: 150,
      isFiltered: true,
    }),
    intCol({
      ident: 'extension',
      display: 'Additional Cause Code',
      width: 150,
      isFiltered: true,
    }),
    strCol({
      ident: 'contributingCondition',
      display: 'Contributing Operating Condition',
      isFiltered: true,
      ...toSelectionColProps(conMap),
      alignment: 'left',
      width: 400,
      ellipsis: true,
    }),
  ]

  const lastHeaders = [
    numCol({
      ident: 'potentialLoss',
      display: 'MWH Loss',
      isFiltered: true,
      width: 200,
    }),
    //   modifierCol,
    //   modifiedDateCol,
  ]

  // const getWidth = hd => hd.map(h => h.width || 100).reduce((a, b) => a + b)

  // let descwidth = width - getWidth(headers) - getWidth(lastHeaders) - 30
  // if (descwidth < 0) descwidth = 150
  // const desc = strCol({
  //   ident: 'description',
  //   display: 'Event Description',
  //   isFiltered: true,
  //   width: descwidth,
  //   ellipsis: true,
  //   alignment: 'left',
  // })
  return headerWithFormatter([...headers, ...lastHeaders])
}

export const PerformanceIoHeaders = [
  // strCol({
  //   ident: 'entityId',
  //   display: 'NCR ID/NERC ID',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isFiltered: true,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'subgroupId',
    display: 'Subgroup ID',
    isFiltered: true,
    width: 200,
    // sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'subgroupName',
  //   display: 'Subgroup Name',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),

  intCol({
    ident: 'month',
    display: 'Reporting Period (Month)',
    width: 300,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'year',
    display: 'Reporting Year',
    width: 200,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'status',
    display: 'Subgroup Status',
    width: 200,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'grossactgen',
    display: 'Gross Actual Generation (GAG)',
    width: 300,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'expectedGen',
    display: 'Expected Generation',
    width: 200,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'netactgen',
    display: 'Net Actual Generation (NAG)',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'netmaxcap',
    display: 'Net Maximum Capacity (NMC)',
    width: 270,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'activeThrs',
    display: 'Active Turbine‐Hours',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'contactThrs',
    display: 'Contact Turbine‐Hours',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'rsThrs',
    display: 'Reserve Shutdown Turbine‐Hours',
    width: 300,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'forcedThrs',
    display: 'Forced Turbine‐Hours',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'maintenanceThrs',
    display: 'Maintenance Turbine‐Hours',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'plannedThrs',
    display: 'Planned Turbine‐Hours',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'ruThrs',
    display: 'Resource Unavailable Turbine‐Hours',
    width: 300,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'inactiveReserveThrs',
    display: 'Inactive Reserve Turbine‐Hours',
    width: 300,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'mothballedThrs',
    display: 'Mothballed Turbine‐Hours',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  numCol({
    ident: 'retiredThrs',
    display: 'Retired Unit Turbine‐Hours',
    width: 250,
    isFiltered: true,
    sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'recordid',
  //   display: 'Recordid',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
  // strCol({
  //   ident: 'action',
  //   display: 'Action',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
]

export const Wind2StorageGroupHeaders = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    xd: 'NCR ID',
    ord: 1,
  }),
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    xd: 'Plant ID',
    ord: 2,
  }),
  strCol({
    ident: 'storageGroupId',
    display: 'Storage Group ID',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    ord: 3,
    xd: 'Energy Storage Group ID',
  }),
  strCol({
    ident: 'storageGroupName',
    display: 'Storage Group Name',
    isrRe: true,
    isRequired: 'asc',
    width: 150,
    ord: 4,
    xd: 'Energy Storage Group Name',
  }),
  strCol({
    ident: 'storageGroupEiaCode',
    display: 'Storage Group EIA Code',
    isKey: true,
    sortOrder: 'asc',
    width: 150,
    ord: 5,
    xd: 'Energy Storage Group EIA Code',
  }),
  strCol({
    ident: 'storageIsoResourceId',
    display: 'Storage Group ISO ID',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    ord: 6,
    xd: 'Energy Storage Group ISO ID',
  }),
  strCol({
    ident: 'commissionDateStr',
    display: 'Commision Date',
    isFiltered: true,
    sortOrder: 'asc',
    xd: 'Commercial Date',
    ord: 13,
  }),
  strCol({
    ident: 'effectiveDateStr',
    display: 'Effective Date (mm/dd/yyyy)',
    sortOrder: 'asc',
    isRequired: true,
    xd: 'Effective Date',
    ord: 18,
  }),
  strCol({
    ident: 'storageOwnershipStatus',
    display: 'Storage Ownership Status',
    sortOrder: 'asc',
    isRequired: true,
    xd: 'Energy Storage Ownership Status',
    ord: 17,
  }),

  strCol({
    ident: 'storageType',
    display: 'Storage Type',
    isFiltered: true,
    sortOrder: 'asc',
    width: 200,
    isRequired: 'asc',
    ord: 7,
    xd: 'Energy Storage Type',
  }),
  numCol({
    ident: 'nameplateCapacity',
    display: 'Nameplate Storage Capacity (MW)',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    isRequired: 'asc',
    ord: 8,
    xd: 'Energy Storage Group Capacity Rating (MW)',
  }),
  numCol({
    ident: 'nameplateEnergy',
    display: 'Nameplate Generating Capacity (MWh)',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    isRequired: 'asc',
    ord: 9,
    xd: 'Energy Storage Group Energy Rating (MWh)',
  }),
  strCol({
    ident: 'connectionType',
    display: 'Connection Type (AC/DC)',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    isRequired: 'asc',
    ord: 9,
    xd: 'Energy Storage Connection',
  }),
  strCol({
    ident: 'chargeableFromGrid',
    display: 'Chargeable from Grid',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    // ...toSelectionColProps(YNBooleanTypes),
    xd: 'Energy Storage Chargeable from Grid',
    ord: 10,
  }),
  strCol({
    ident: 'storageManufacturer',
    display: 'Storage Manufacturer',
    isFiltered: true,
    sortOrder: 'asc',
    width: 150,
    isRequired: 'asc',
    ord: 11,
    xd: 'Energy Storage Manufacturer',
  }),
  strCol({
    ident: 'storageModel',
    display: 'Storage Model',
    isFiltered: true,
    sortOrder: 'asc',
    isRequired: 'asc',
    ord: 12,
    xd: 'Energy Storage Model',
  }),

  strCol({
    ident: 'storageInvManufacturer',
    display: 'Storage Inverter Manufacturer',
    isFiltered: true,
    sortOrder: 'asc',
    isRequired: 'asc',
    xd: 'Energy Storage inverter Manufacturer',
    ord: 14,
  }),
  strCol({
    ident: 'storageInvModel',
    display: 'Storage Inverter Model',
    isFiltered: true,
    sortOrder: 'asc',
    isRequired: 'asc',
    ord: 15,
    xd: 'Energy Storage Inverter Model',
  }),

  // strCol({
  //   ident: 'transferToEntityId',
  //   display: 'Transfer to Entity ID',
  //   isFiltered: true,
  //   sortOrder: 'asc',
  // }),
]

export const Wind2StoragePerformanceIoHeaders = [
  strCol({
    ident: 'plantId',
    display: 'Plant ID',
    isFiltered: true,
    sortOrder: 'asc',
    xd: 'Plant ID',
    ord: 1,
    width: 250,
  }),
  strCol({
    ident: 'storageGroupId',
    display: 'Inverter Group ID',
    isFiltered: true,
    sortOrder: 'asc',
    width: 250,
    sortIndexGetter: ({ rowData }) =>
      rowData.storageGroupId === 'TOTAL' ? 'ZZZZZZZ' : rowData.storageGroupId,
    xd: 'Storage Group ID',
    ord: 2,
  }),
  intCol({
    ident: 'year',
    display: 'Year',
    isFiltered: true,
    sortOrder: 'asc',
    ord: 4,
    xd: 'Reporting Year',
    width: 150,
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isFiltered: true,
    sortOrder: 'asc',
    xd: 'Reporting Period (Month)',
    width: 150,
    ord: 3,
  }),
  strCol({
    ident: 'storageGroupAvailability',
    display: 'Availability Status',
    isFiltered: true,
    sortOrder: 'asc',
    // ...toSelectionColProps(avalibilityStatusIdMap),
    xd: 'Storage Group Availability Status',
    ord: 5,
    width: 150,
  }),
  numCol({
    ident: 'chargeMwh',
    display: 'Charge MWh',
    isFiltered: true,
    sortOrder: 'asc',
    ord: 6,
    xd: 'Charge Generation',
    width: 150,
  }),
  numCol({
    ident: 'dischargeMwh',
    display: 'Discharge MWh',
    isFiltered: true,
    sortOrder: 'asc',
    xd: 'Discharge Generation',
    ord: 7,
    width: 150,
  }),
  numCol({
    ident: 'chargeHrs',
    display: 'Charge Hrs',
    isFiltered: true,
    sortOrder: 'asc',
    xd: 'Charging Hours',
    ord: 8,
    width: 150,
  }),
  numCol({
    ident: 'dischargeHrs',
    display: 'Discharge Hrs',
    isFiltered: true,
    sortOrder: 'asc',
    xd: 'Discharging Hours',
    ord: 9,
    width: 150,
  }),
  numCol({
    ident: 'foHrs',
    display: 'FO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
    ord: 10,
    xd: 'Forced Outage Hours',
    width: 150,
  }),
  numCol({
    ident: 'moHrs',
    display: 'MO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
    ord: 11,
    xd: 'Maintenance Outage Hours',
    width: 150,
  }),
  numCol({
    ident: 'poHrs',
    display: 'PO Hrs',
    isFiltered: true,
    sortOrder: 'asc',
    xd: 'Planned Outage Hours',
    ord: 12,
    width: 150,
  }),
]

export const Wind2NercEventHeadersImport = _ => {
  // const conMap = R.compose(
  //   R.fromPairs,
  //   R.map(d => [d.contOpCode, d.contOpCode + ' - ' + d.contOpCondition])
  // )(contribConditionList)

  const headers = [
    // strCol({ ident: 'entityId', display: 'NCR ID/NERC ID', isKey: true }),
    strCol({ ident: 'plantId', display: 'Plant ID', isKey: true }),
    strCol({
      ident: 'eventId',
      display: 'Event ID',
      // isKey: true,
      sortOrder: 'asc',
    }),
    // strCol({ ident: 'timeZone', display: 'Time Zone', isKey: true }),
    dateTimeCol({
      ident: 'eventStart',
      display: 'Event Start',
      isKey: true,
      width: 150,
      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
      sortOrder: 'asc',
    }),
    dateTimeCol({
      ident: 'eventEnd',
      display: 'Event End',
      isFiltered: true,
      width: 150,
      displayFormat: 'MM/DD/YYYY HH:mm',
      dataFormat: 'MM/DD/YYYY HH:mm',
      // sortOrder: 'asc',
    }),
    strCol({ ident: 'eventType', display: 'Event Type', isFiltered: true }),
    intCol({ ident: 'causeCode', display: 'Causecode', isFiltered: true }),
    strCol({
      ident: 'contribCondition',
      display: 'Contributing Operating Condition',
      isFiltered: true,
      // ...toSelectionColProps(conMap),
      alignment: 'left',
      width: 150,
      ellipsis: true,
    }),
    numCol({
      ident: 'potentialLoss',
      display: 'Potential Generation Loss (MWh)',
      isFiltered: true,
      width: 200,
    }),
  ]

  // const getWidth = hd => hd.map(h => h.width || 100).reduce((a, b) => a + b)

  // let descwidth = width - getWidth(headers) - 30
  // if (descwidth < 0) descwidth = 150
  const desc = strCol({
    ident: 'description',
    display: 'Event Description',
    isFiltered: true,
    width: 500,
    ellipsis: true,
    alignment: 'left',
  })
  const extCauseCode = R.range(1, 11).map(i =>
    strCol({
      ident: 'causeCodeExt' + i,
      display: 'Causecode Ext ' + i,
    })
  )
  return [...headers, ...extCauseCode, desc]
}

export const Wind2SubgroupHeadersImport = [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isKey: true,
    width: 200,
  }),
  strCol({ ident: 'plantId', display: 'Plant ID', isKey: true }),
  // strCol({ ident: 'groupIdName', display: 'Group ID/Name', isFiltered: true }),
  intCol({ ident: 'subgroupId', display: 'Subgroup ID', isKey: true }),
  strCol({
    ident: 'subgroupName',
    display: 'Subgroup Name',
    isFiltered: true,
    isRequired: true,
    width: 300,
    ellipsis: true,
  }),
  numCol({
    ident: 'elevation',
    display: 'Elevation (m)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'windRegime',
    display: 'Wind Regime',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'annualAvgWindspeed',
    display: 'Annual Avg Windspeed (m/s)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'scadaManufacturer',
    display: 'SCADA Manufacturer',
    isFiltered: true,
    width: 100,
    isRequired: true,
  }),
  strCol({
    ident: 'scadaModel',
    display: 'SCADA Model',
    isFiltered: true,
    isRequired: true,
  }),
  dateCol({
    ident: 'commissionDateStr',
    display: 'Commision Date (mm/dd/yyyy)',
    isFiltered: true,
    dataFormat: 'MM/DD/YYYY',
    isRequired: true,
  }),
  dateCol({
    ident: 'effectiveDateStr',
    display: 'Effective Date (mm/dd/yyyy)',
    isFiltered: true,
    dataFormat: 'MM/DD/YYYY',
    isRequired: true,
  }),
  numCol({
    ident: 'totalInstalledCap',
    display: 'Total Installed Cap (MW)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'numberTurbines',
    display: 'Number of Turbines',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'trubineSystemMw',
    display: 'Turbine System Cap (MW)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'maxTurbineCapacity',
    display: 'Max Turbine Cap (MW)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineManufacturer',
    display: 'Turbine Manufacturer',
    isFiltered: true,
    width: 100,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineModel',
    display: 'Turbine Model',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineModelVersion',
    display: 'Turbine Model Version',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'trubineType',
    display: 'Turbine Type',
    isFiltered: true,
    width: 100,
    alignment: 'left',
    ellipsis: true,
    isRequired: true,
  }),
  numCol({
    ident: 'rotorHeight',
    display: 'Rotor Height (m)',
    isFiltered: true,
    isRequired: true,
    min: 0,
  }),
  numCol({
    ident: 'rotorDiameter',
    display: 'Rotor Diameter (m)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'cutInWindspeed',
    display: 'Cut-in Wind Speed (m/s)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'lowCutOutWindspeed',
    display: 'Low Cut-Out (m/s)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'highCutOutWindspeed',
    display: 'High Cut-Out (m/s)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'turbulenceIntensity',
    display: 'Turbulence Intensity',
    isFiltered: true,
    alignment: 'left',
    ellipsis: true,
    width: 100,
    isRequired: true,
  }),
  numCol({
    ident: 'windShearId',
    display: 'Wind Shear',
    isFiltered: true,
    alignment: 'left',
    ellipsis: true,
    width: 100,
    isRequired: true,
  }),
  numCol({
    ident: 'refAnemometerHeight',
    display: 'Ref. Anemometer Height',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'minOperatingTemp',
    display: 'Min Operating Temp (C)',
    isFiltered: true,
    isRequired: true,
  }),
  numCol({
    ident: 'maxOperatingTemp',
    display: 'Max Operating Temp (C)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'subgroupOwnershipStatus',
    display: 'Subgroup Ownership Status',
    isFiltered: true,
    isRequired: true,
  }),
]

export const Wind2PlantHeaders = regionMap => [
  strCol({
    ident: 'entityId',
    display: 'NCR ID/NERC ID',
    isKey: true,
    width: 200,
    maxLength: 10,
  }),
  strCol({
    ident: 'region',
    display: 'Region',
    isKey: true,
    width: 300,
    ...toSelectionColProps(regionMap),
  }),
  strCol({ ident: 'plantId', display: 'Plant ID', isKey: true, maxLength: 10 }),
  strCol({
    ident: 'plantName',
    display: 'Plant Name',
    isRequired: true,
    sortOrder: 'asc',
  }),
  strCol({ ident: 'eiaPlantCode', display: 'EIA Plant Code', isKey: true }),
  strCol({ ident: 'isoResourceId', display: 'ISO ID', isFiltered: true }),

  strCol({
    ident: 'plantOwnershipStatus',
    display: 'Plant Ownership Status',
    isKey: false,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'country',
    display: 'Country',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'stateProvince',
    display: 'State/Province',
    isFiltered: true,
    width: 200,
    maxLength: 2,
    isRequired: true,
  }),
  strCol({
    ident: 'nearestCity',
    display: 'Nearest City',
    isFiltered: true,
    width: 200,
  }),

  strCol({
    ident: 'timeZone',
    display: 'Time Zone',
    isFiltered: true,
    width: 200,
    isRequired: true,
  }),
  strCol({
    ident: 'daylightSaving',
    display: 'Daylight Saving',
    isFiltered: true,
    keymap: yesNoMap,
    isRequired: true,
    // ...toSelectionColProps(yesNoMap),
    ...toSelectionColProps(yesNoYNMap),
  }),
  strCol({
    ident: 'latitude',
    display: 'Latitude (DD)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'longitude',
    display: 'Longitude (DD)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'onSiteStorage',
    display: 'On-Site Storage (Yes/No)',
    isFiltered: true,
    isRequired: true,
    // keymap: yesNoYNMap,
    ...toSelectionColProps(yesNoYNMap),
  }),
  numCol({
    ident: 'plantCapPoi',
    display: 'Plant Capacity at POI (MW)',
    isFiltered: true,
    isRequired: true,
  }),
  strCol({
    ident: 'effectiveDateStr',
    display: 'Effective Date (mm/dd/yyyy)',
    isFiltered: true,
    isRequired: true,
  }),
]
